import React from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../firebase';
import AdminLogin from './AdminLogin';
import './VolunteerSignup.css';

export default function VolunteerAuthGate({ children }) {
  const [user, loading] = useAuthState(auth);

  if (loading) {
    return (
      <div className="volunteer-page">
        <div className="volunteer-page__loading">Loading…</div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="volunteer-page volunteer-page--login">
        <div className="volunteer-page__login-card">
          <AdminLogin redirectTo="/volunteer" title="Volunteer sign-in" />
        </div>
      </div>
    );
  }

  return children;
}
